import React from "react";
import { CircleHelp } from "lucide-react";

export default function TermHelp({ term, children, align = "left" }) {
  return (
    <details className={`term-help term-help-${align}`}>
      <summary aria-label={`คำอธิบาย ${term}`} title={`คำอธิบาย ${term}`}>
        <CircleHelp size={15} aria-hidden="true" />
      </summary>
      <div role="note"><strong>{term}</strong><span>{children}</span></div>
    </details>
  );
}
